import { baseStoreCreator } from '@/utils/store';

export enum PlanStatuses {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PENDING_ACTIVE = 'PENDING_ACTIVE',
  READY_FOR_SETUP = 'READY_FOR_SETUP',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  PENDING_TERMINATION = 'PENDING_TERMINATION',
  TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
  TERMINATED = 'TERMINATED',
  PENDING_REACTIVATION = 'PENDING_REACTIVATION',
}
export interface PlanNamePayload {
  planStatus: PlanStatuses;
  planName: string;
  planType: string;
  planNotes: string;
  planCode: string;
  planTemplate: string;
  priorPlanId: string;
  isFirstPlan: boolean;
  planSummary: string;
}

export const DEFAULT_VALUES: PlanNamePayload = {
  planName: '',
  planStatus: PlanStatuses.DRAFT,
  planType: '',
  planNotes: '',
  planCode: '',
  planTemplate: '',
  priorPlanId: '',
  isFirstPlan: false,
  planSummary: '',
};

const usePlanNameStore = baseStoreCreator<PlanNamePayload>(DEFAULT_VALUES);

export default usePlanNameStore;
